import { defineStore } from "pinia";
import userService from "../services/user.service.ts";
import { cacheFetch } from "../utils/cache";

function minutes(m) {
  return m * 60 * 1000;
}

export const useUserStore = defineStore("user", {
  state: () => ({
    settings: null,
    settingsFetchedAt: null,
    authSettings: null,
    authSettingsFetchedAt: null,
    serverConfigSettings: null,
    serverConfigSettingsFetchedAt: null,
    license: null,
    licenseFetchedAt: null,
    agents: null,
    agentsFetchedAt: null,
    apiKeys: null,
    apiKeysFetchedAt: null,
    backends: null,
    backendsFetchedAt: null,
    acls: null,
    aclsFetchedAt: null,
    knocs: null,
    knocsFetchedAt: null,
    groups: null,
    groupsFetchedAt: null,
    users: null,
    usersFetchedAt: null,
    admins: null,
    adminsFetchedAt: null,
  }),

  persist: {
    pick: [
      "settings",
      "settingsFetchedAt",
      "authSettings",
      "authSettingsFetchedAt",
      "serverConfigSettings",
      "serverConfigSettingsFetchedAt",
      "license",
      "licenseFetchedAt",
      "agents",
      "agentsFetchedAt",
      "apiKeys",
      "apiKeysFetchedAt",
      "backends",
      "backendsFetchedAt",
      "acls",
      "aclsFetchedAt",
      "knocs",
      "knocsFetchedAt",
      "groups",
      "groupsFetchedAt",
      "users",
      "usersFetchedAt",
      "admins",
      "adminsFetchedAt",
    ],
  },

  actions: {
    async fetchSettings(options = {}) {
      return cacheFetch({
        state: this,
        key: "settings",
        fetchFn: () => userService.getSettings(),
        ttl: minutes(3),
        ...options,
      });
    },

    async fetchAuthSettings(options = {}) {
      return cacheFetch({
        state: this,
        key: "authSettings",
        fetchFn: () => userService.getAuthenticationSettings(),
        ttl: minutes(3),
        ...options,
      });
    },

    async fetchServerConfigSettings(options = {}) {
      return cacheFetch({
        state: this,
        key: "serverConfigSettings",
        fetchFn: () => userService.getServerConfigSettings(),
        ttl: minutes(3),
        ...options,
      });
    },

    async fetchLicenseStatus(options = {}) {
      return cacheFetch({
        state: this,
        key: "license",
        fetchFn: () => userService.getLicenseStatus(),
        ttl: minutes(3),
        ...options,
      });
    },

    async fetchAgents(options = {}) {
      return cacheFetch({
        state: this,
        key: "agents",
        fetchFn: () => userService.getAgents(),
        ttl: minutes(3),
        ...options,
      });
    },

    // async fetchAgent(id, options = {}) {
    //   if (options.force || !this.agents) {
    //     return userService.getAgent(id);
    //   }
    //   return this.agents.find((agent) => agent.id === id);
    // },

    async fetchApiKeys(options = {}) {
      return cacheFetch({
        state: this,
        key: "apiKeys",
        fetchFn: () => userService.getApiKeys(),
        ttl: minutes(3),
        ...options,
      });
    },

    // async fetchApiKey(id, options = {}) {
    //   if (options.force || !this.apiKeys) {
    //     return userService.getApiKey(id);
    //   }
    //   return this.apiKeys.find((agent) => agent.id === id);
    //
    // }

    async fetchBackends(options = {}) {
      return cacheFetch({
        state: this,
        key: "backends",
        fetchFn: () => userService.getBackends(),
        ttl: minutes(3),
        ...options,
      });
    },

    async fetchAcls(options = {}) {
      return cacheFetch({
        state: this,
        key: "acls",
        fetchFn: () => userService.getAcls(),
        ttl: minutes(3),
        ...options,
      });
    },

    async fetchKnocs(options = {}) {
      return cacheFetch({
        state: this,
        key: "knocs",
        fetchFn: () => userService.getKnocs(),
        ttl: minutes(3),
        ...options,
      });
    },

    async fetchGroups(options = {}) {
      return cacheFetch({
        state: this,
        key: "groups",
        fetchFn: () => userService.getGroups(),
        ttl: minutes(3),
        ...options,
      });
    },

    async fetchUsers(options = {}) {
      return cacheFetch({
        state: this,
        key: "users",
        fetchFn: () => userService.getUsers(),
        ttl: minutes(3),
        ...options,
      });
    },

    async fetchAdmins(options = {}) {
      return cacheFetch({
        state: this,
        key: "admins",
        fetchFn: () => userService.getAdmins(),
        ttl: minutes(3),
        ...options,
      });
    },
  },
});
